import { TableConfig } from "../../../../../common/tables/config/TableConfig";
import { PLPRTableRow } from "../../../../../../../common/tables/product-listing/payout-rule-mapping/PLPRTableRow";
import { SortOrder } from "../../../../../../../common/query-filters";
import { CellType } from "../../../../../common/tables/config/CellType";

export const DefaultPLPRTableConfig: TableConfig<PLPRTableRow> = {
    columns: [
        {
            columnName: "payoutRuleName",
            displayName: "Payout Rule",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "180px",
            sortable: true,
            filterable: true,
        },
        {
            columnName: "payoutRuleType",
            displayName: "Type",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: true,
            filterable: true,
        },
        {
            columnName: "startDate",
            displayName: "Start Date",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "startThreshold",
            displayName: "Start Threshold",
            cellType: CellType.numberInput,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "150px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "costPayoutModifierName",
            displayName: "Cost Payout Modifier",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "180px",
            sortable: false,
            filterable: false,
            textAlign: "left",
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "startDate",
        pageSize: 50,
    },
};
